<template>
  <div class="qq-popup-component">
    <div class="title">{{contentList[contentType].title}}</div>
    <div class="content">{{contentList[contentType].content}}</div>
    <div class="qq-message-img">
      <!-- <img v-if="!this.$root.miniprogram" :src="require(`../../../assets/img/productDetail/${contentList[contentType].imgUrl}`)" alt="" /> -->
      <img  :src="communityInfo.qrcode" alt="">
    </div>
    <p class="tips" v-if="this.$root.miniprogram"><span>请长按上方二维码保存图片，前往QQ扫描二维码添加</span></p>
    <div class="footer" v-if="!this.$root.miniprogram">
      <div class="footer-btn" @click="goPage">立即前往QQ添加</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    communityInfo: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      contentList: {
        group: {
          title: '加入备考群',
          content: '领取学习资料和更多小伙伴一起备考',
          imgUrl: 'qq_group_bg.png',
        },
        person: {
          title: '添加助教',
          content: '添加助教老师，获得更多课程资料及个性化服务',
          imgUrl: 'qq_message.png',
        },
      },
      contentType: 'group',
    };
  },
  mounted() {
    if (this.communityInfo.accountType === 1) {
      this.contentType = 'group';
    } else {
      this.contentType = 'person';
    }
  },
  methods: {
    goPage() {
      if (this.$root.$data.isApp) {
        if (this.contentType === 'group') {
          this.$sendToApp('addQQGroup', {
            url: this.communityInfo.linkUrl,
          });
        } else if (this.contentType === 'person') {
          this.$sendToApp('addQQ', {
            QRCodeUrl: this.communityInfo.account,
          });
        }
      } else if (this.communityInfo.linkUrl) {
        window.location.href = this.communityInfo.linkUrl;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.qq-popup-component {
  position: relative;
  width: 100%;
  height: 850px;
  overflow: hidden;
  background: url("../../../assets/img/productDetail/qq_icon.png") 0 0 no-repeat;
  background-size: 275px 351px;

  .title {
    width: 100%;
    margin-top: 58px;
    color: #333;
    font-weight: blod;
    font-size: 43px;
    line-height: 60px;
    text-align: center;
  }

  .content {
    width: 100%;
    margin-top: 58px;
    color: #333;
    font-weight: blod;
    font-size: 29px;
    line-height: 40px;
    text-align: center;
  }

  .qq-message-img {
    width: 100%;
    margin-top: 58px;
    text-align: center;

    img {
       width: 326px;
      height: 326px;
    }
  }

  .footer {
    display: flex;
    justify-content: center;
    width: 100%;

    .footer-btn {
      width: 634px;
      height: 90px;
      margin-top: 29px;
      color: white;
      font-size: 36px;
      line-height: 90px;
      text-align: center;
      background: #FF6C02;
      border-radius: 14px;
    }
  }
}

  .tips {
    width: 100%;
    margin-top: 14px;
    text-align: center;

    span {
      display: inline-block;
      // width: 500px;
      color: #a5a5a5;
      font-size: 22px;
      line-height: 31px;
    }
  }
</style>
